"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Switch.default;
  }
});

var _Switch = _interopRequireDefault(require("./Switch"));


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/Switch/index.js
// module id = 84
// module chunks = 0